var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"#282a36","dark":""}},[_c('v-toolbar-title',[_vm._v("Vuehub")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"","href":"https://github.com/caiopeternela/vuehub","target":"_blank"}},[_c('v-icon',[_vm._v("mdi-github")])],1)],1),_c('v-main',[_c('VueHub')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }